module.exports = __webpack_public_path__ + "img/1.8fb3d120.png";